export default {
  vehiclesType: {
    CUSTOM: 'Tùy chỉnh',
    AIRPLANE: 'Máy bay',
    CAR: 'Ô tô',
    TRAIN: 'Tàu hỏa',
    HIGH_SPEED_TRAIN: 'Tàu cao tốc',
  },
  tourType: {
    DOMESTIC: 'Nội địa',
    OUTBOUND: 'Quốc tế',
  },
  msg: {
    selectedTourNotFound: 'Vui lòng chọn lại tour!',
    agencyPlaceholder: 'Chọn đại lý để đặt tour',
  },
  field: {
    contactName: 'Họ và tên',
    contactPhone: 'Số điện thoại',
    email: 'Email',
    address: 'Địa chỉ',
    type: 'Loại khách',
    unitPrice: 'Giá/người',
    commission: 'Hoa hồng',
    totalCommission: 'Tổng hoa hồng',
    number: 'Số',
    totalAmount: 'Tổng số tiền',
    chooseAgency: 'Chọn đại lý',
    agency: 'Đại lý',
    totalSingleRoom: 'Tổng phòng đơn',
  },
  ph: {
    contactName: 'Nhập họ và tên',
    contactPhone: 'Nhập số điện thoại',
    email: 'Nhập email',
    address: 'Nhập địa chỉ',
  },
  passenger: {
    Adults: 'Người lớn',
    Children1: 'Trẻ em 1',
    Children2: 'Trẻ em 2',
    Infant: 'Trẻ sơ sinh',
    ageFrom: 'Từ {ageFrom} yo ở trên',
    ageBetween: 'Từ {ageFrom}-{ageTo} yo',
    ageTo: 'Dưới {ageTo} yo',
  },
  totalPrice: 'Tổng giá',
  displaySettings: 'Hiển thị',
  tableColumns: {
    no: 'Không.', // Không.
    bookingCode: 'Mã đặt chỗ', // Mã đặt chỗ
    status: 'Trạng thái', // Trạng thái
    customerName: 'Tên khách hàng', // Tên khách hàng
    tourName: 'Tên tour', // Tên tour
    startDate: 'Ngày bắt đầu', // Ngày bắt đầu
    totalPrice: 'Tổng giá', // Tổng giá
    totalCommission: 'Tổng hoa hồng', // Tổng hoa hồng
    createdAt: 'Ngày tạo', // Ngày tạo
    createdBy: 'Ngày tạo', // Ngày tạo
    note: 'Ghi chú', // Ghi chú
    actions: 'Hành động', // Hành động
    totalPriceToBePaid: 'Tổng giá cần thanh toán',
    totalPriceRefund: 'Tổng tiền hoàn lại',
    depositPrice: 'Đã gửi / Đã thanh toán',

    paxType: 'Loại khách',
    tourPrice: 'Giá tour',
    paxQuantity: 'Số lượng',
    // totalPrice: 'Tổng giá',
  },
  status: {
    pendingPayment: 'Chờ thanh toán',
    done: 'Hoàn thành',
    canceled: 'Đã huỷ',
    confirming: 'Chờ xác nhận',
    ALL: 'Tất cả',
    RESERVED: 'Reserved', // Giữ chỗ
    DEPOSITED: 'Deposited', // Đã đặt cọc
    REQUEST_DEPOSIT: 'Yêu cầu gửi tiền',
    REQUEST_PAYMENT: 'Yêu cầu thanh toán',
    REQUEST_UPDATE: 'Yêu cầu cập nhật',
    PAID: 'Đã thanh toán', // Đã thanh toán
    CANCELLATION_REQUESTED: 'Yêu cầu hủy', // Yêu cầu hủy
    CANCELLED: 'Đã hủy', // Đã hủy
    EXPIRED: 'Đã hết hạn',
  },
  showCommission: 'Hiển thị hoa hồng',
  hideCommission: 'Ẩn hoa hồng',
  bookingDetail: {
    tourInfo: 'Thông tin tour',
    contactInfo: 'Thông tin liên hệ',
    paymentDeadline: 'Hạn chót thanh toán',
    timeHold: 'Thời gian giữ',
  },
  historyActions: {
    CREATE: 'Đặt tour',
    CONFIRM_PAYMENT: 'Đã xác nhận đặt cọc/thanh toán',
    CONFIRM_UPDATE: 'Đã xác nhận cập nhật',
    REQUEST_CANCEL: 'Yêu cầu hủy tour',
    REQUEST_SUPPORT: 'Xác nhận tour',
  },
  startDate: 'Từ ngày',
  endDate: 'Đến ngày',
  bankAcc: 'Tài khoản nhận tiền',
  placeholderSelectDate: 'Chọn ngày',
  placeholderSearch: 'Tìm kiếm theo mã thanh toán, tên người gửi, tên ngân hàng',
  moreDropdownTitle: '',

  currency: 'VND',
  detail: 'Chi Tiết Nạp tiền',
  tabInfo: 'Thông Tin Nạp tiền',
  confirm: 'Xác nhận',
  confirmManual: 'Xác nhận nạp tiền thủ công',
  delete: 'Xoá',
  errFetchData_1: 'Lỗi tìm nạp dữ liệu nạp tiền',
  errFetchData_2: 'Không tìm thấy khoản nạp tiền nào với id của khách hàng này. Kiểm tra',
  errFetchData_3: 'khoản nạp tiền khác.',

  createTopup: 'Tạo lệnh nạp tiền',
  createTopupForChild: 'Tạo lệnh nạp tiền cho đại lý',
  tooltip: {
    allowTopup: 'Chỉ các đại lý đã kí hợp đồng mới được tạo lệnh nạp tiền, vui lòng liên hệ Booker để được hỗ trợ',
  },
  btn: {
    requestSupport: 'Xác nhận Tour',
    requestedSupport: 'Tour đã xác nhận',
  },
  suggestedTours: 'Tour được đề xuất',
  duration: 'Thời lượng',
  durationWith: '{totalDay} Ngày {totalNight} Đêm',
  SearchingSuitableTourPackages: 'Chúng tôi đang tìm kiếm các gói tour phù hợp cho bạn.',
  noTourSuggestionsReferAvailableTours: 'Không có gợi ý tour nào cho đặt chỗ này. Vui lòng tham khảo các tour khác có sẵn',
  here: 'here',
  detailView: 'Xem chi tiết',
  titleRepicient: 'Yêu cầu nạp tiền',
  titleSender: 'Nạp tiền',
  management: 'Quản Lý Nạp Tiền',
  list: 'Danh Sách Nạp tiền',
  paymentStatus: 'Trạng thái thanh toán',
  amount: 'Số tiền',
  paymentAmount: 'Số tiền thanh toán',
  senderId: 'Mã số bên gửi',
  senderName: 'Bên gửi',
  entity: 'Vai trò',
  senderEntity: 'Vai trò bên gửi',
  recipientId: 'Mã số bên nhận',
  recipientEntity: 'Vai trò bên nhận',
  bankAccountName: 'Tên tài khoản ngân hàng',
  bankAccountNo: 'Số tài khoản ngân hàng',
  note: 'Ghi chú',
  evidence: 'Bằng chứng',
  uploadEvidence: 'Tải lên hình ảnh bằng chứng',
  placeholderChooseImage: 'Chọn một hình ảnh hoặc thả nó ở đây...',
  placeholderDropImage: 'Thả hình ảnh ở đây...',
  evidenceUrl: 'Tài liệu bằng chứng nạp tiền',
  bankCode: 'Mã ngân hàng',

  confirmAutoPayment: 'Tự động xuất vé theo đơn hàng',
  at: 'lúc',
  sender: 'Đại lý nạp tiền',
  recipient: 'Đại lý nhận tiền',
  placeholderSender: 'Vui lòng chọn đại lý nạp tiền',
  pleaseTopupMinAmount: 'Vui lòng nạp tiền tối thiểu {minAmount} VNĐ',
  topupInfo: 'Thông tin nạp tiền',
  parentAgencyNotHaveBankAccount: 'Đại lý cấp trên chưa cài đặt tài khoản nhận tiền. Vui lòng liên hệ đại lý cấp trên.',
  createQrSuccess: 'Đã tạo lệnh nạp tiền thành công. Vui lòng quét mã QR để nạp tiền.',
  history: 'Lịch sử nạp tiền',
  viewDetails: 'Xem chi tiết',
  noHistoryRecord: 'Không có lịch sử nạp tiền',
}
